import React from 'react';
import HeroScrollAnimation from './ui/hero-scroll-animation';
import ScrollExpandMedia from './ui/scroll-expansion-hero';

const GameWithVideo: React.FC = () => {
  return (
    <div className="w-full">
      {/* First three sections with normal scroll animation */}
      <HeroScrollAnimation />
      
      {/* Section 4 - Lies of P Video with Scroll Expansion Effect */}
      <div className='relative z-20 bg-black -mt-1'>
        <ScrollExpandMedia
          mediaType='video'
          mediaSrc='/photo/liesofp.mov'
          bgImageSrc='/photo/liesofpbackgound.png'
          title='Lies of P'
          date='I love playing Souls-like and RPG games. Dark worlds, brutal challenges, and the thrill of discovery always draw me in. Recently, my favorite has been Lies of P which is a masterpiece with a gripping story and haunting music that pulls me deeply into its world. The combat feels weighty and precise, every strike full of impact, every battle a true test of patience and skill. What I enjoy most is how it blends atmosphere, challenge, and emotion, turning every defeat into motivation and every victory into triumph.'
          scrollToExpand='Scroll to Expand'
        />
      </div>
    </div>
  );
};

export default GameWithVideo;